import React, { useEffect } from 'react'
import cssModules from 'react-css-modules'
import styles from './index.less'
import PropTypes from 'prop-types'
// eslint-disable-next-line import/no-unresolved
import { hydrate } from '@paypalcorp/globalnavsdk/client'

const Header = ({ headerHtml }) => {
  useEffect(
    () => {
      if (headerHtml && window.__GLOBALNAV__?.header) {
        hydrate('header')
      }
    },
    [headerHtml]
  )

  return (
    <div
      styleName="header__container"
      data-testid="header__container"
      dangerouslySetInnerHTML={{ __html: headerHtml }}
    />
  )
}

Header.propTypes = {
  headerHtml: PropTypes.string.isRequired,
}

export default cssModules(Header, styles)
